module.exports = __webpack_public_path__ + "img/goldtalentnomicslogo.d43ca7b4.jpg";